<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <div class="text-center">
                <img
                    class="wrapper_title_logo"
                    src="@/assets/home/logo-new-theme.png"
                />
            </div>
            <div class="main-container">
                <div class="title">
                    {{ title }}
                </div>
                <div class="Line-18"></div>
                <div class="desc">
                    {{ desc }}
                </div>
            </div>
            <!-- <div class="profile-container">
                <div class="profile-image">
                    <img :src="line_image" alt="line-image" />
                </div>
                <div class="point-container">
                    <div class="nestle-point">
                        คุณมี {{profile.updated_points ? numberWithCommas(profile.updated_points.points) : ""}} คะแนน
                    </div>
                    <div class="expire-date" v-if="expire_point.points > 0">
                        <p>
                            {{ expire_point.points }} คะแนน จะหมดอายุภายใน
                            31 ธันวาคม 2566
                        </p>
                    </div>
                </div>
            </div>
            <div class="inactive-body">
                <div class="inactive-title">
                    คุณต้องการยกเลิกการเป็นสมาชิก Nescafé Street Café
                </div>
                <div class="white-line"></div>
                <div class="inactive-desc">ต้องการให้ระบบเก็บข้อมูลส่วนตัวของคุณสำหรับการเข้าใช้งานในครั้งถัดไปหรือไม่</div>
                <div class="btn-container">
                    <div id="inactiveuser-keepdata-btn" @click="setInformation(true)" class="brown-btn">
                        <img src="@/assets/icon/icon_check.svg" alt="">
                        ต้องการเก็บข้อมูล
                    </div>
                    <div id="inactiveuser-notkeepdata-btn" @click="setInformation(false)" class="gray-btn">
                        <img src="@/assets/icon/icon_cancel.svg" alt="">
                        ไม่ต้องการเก็บข้อมูล
                    </div>
                </div>
            </div>
            <b-modal
                id="modalInactive"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="order-main">
                    <div class="order-header">
                        <div class="title-scc">
                            <h2>
                                ยืนยันการยกเลิกเป็นสมาชิก
                            </h2>
                        </div>
                    </div>
                    <div id="inactiveuser-inactivemodal-confirm-btn" @click="confirmDeactive()" class="brown-btn">
                        ยืนยัน
                    </div>
                    <div id="inactiveuser-inactivemodal-cancel-btn" class="underline-btn" @click="$bvModal.hide('modalInactive')">
                        ยกเลิก
                    </div>
                </div>
            </b-modal>
             <b-modal
                id="modalSuccessDeactive"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="order-main">
                    <div class="order-header">
                        <div class="title-scc">
                            <h2>
                               ยกเลิกการเป็นสมาชิกสำเร็จ !
                            </h2>
                        </div>
                        <div class="success-desc">คุณยกเลิกการเป็นสมาชิกเสร็จเรียบร้อยแล้ว</div>
                    </div>
                    <div id="inactiveuser-successmodal-confirm-btn" class="brown-btn" @click="$router.push('/linelogin');">
                        ตกลง
                    </div>
                </div>
            </b-modal> -->
            <!-- <Footer :settabactive="'profile'" /> -->
        </div>
    </div>
</template>

<script>
// import moment from "moment";
//helper
// import CacheHelper from "@/helper/CacheHelper.js";
//service
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
// import BzbsApi from "@/core/Account/service/BzbsProfile.js";
// import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
//component
// import Footer from "@/components/Footer/Footer.vue";

export default {
    name: "active-user",
    // components: {
    //     Footer
    // },
    data() {
        return {
            // line_image: null,
            // cacheHelper: new CacheHelper(),
            // tokenbzbs: '',
            // expire_point: { points: 0 },
            // profile: {},
            // information: ''
            title: "",
            desc: "",
        };
    },
    created: function () {
        // this.line_image = this.cacheHelper.getCache("BzbsUser").line.pictureUrl;
        // this.tokenbzbs = this.cacheHelper.getCache("BzbsUser").token;
        // this.getExpirePoint();
        // this.getProfile();
        this.getBlob();
    },
    methods: {
        getBlob() {
            const url =
                "/nestle/nescafe_streetcafe/custom/nescafe_streetcafe_content.json";
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then((response) => {
                        console.log(response);
                        (this.title =
                            response.inactive_user.unsubscribe.strHeadLine),
                            (this.desc =
                                response.inactive_user.unsubscribe.strMesage),
                            resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // getProfile() {
        //     BzbsApi.getProfile(
        //         this.cacheHelper.getCache("BzbsUser").token
        //     ).then(response => {
        //         this.profile = response.data;
        //     });
        // },
        // confirmDeactive() {
        //     this.$bvModal.hide('modalInactive');
        //     BzbsAuth.apiDeactive(this.tokenbzbs, this.information)
        //     .subscribe(
        //         data => {
        //             console.log(data)
        //         },
        //     )
        //     this.$bvModal.show('modalSuccessDeactive')
        // },
        // numberWithCommas(x) {
        //     if (x) {
        //         return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        //     } else if (x == 0) {
        //         return 0;
        //     } else {
        //         return "-";
        //     }
        // },
        // getExpirePoint() {
        //     return new Promise(resolve => {
        //         BzbsApi.getExpirePoint(
        //             this.cacheHelper.getCache("BzbsUser").token
        //         ).then(response => {
        //             if (response.data.expiring_points[0]) {
        //                 this.expire_point.points =
        //                     response.data.expiring_points[0].points;
        //                 this.expire_point.time = moment
        //                     .unix(response.data.expiring_points[0].time)
        //                     .utc()
        //                     .add(543, "year")
        //                     .format("DD MMMM YYYY");
        //             }
        //             resolve(response);
        //         });
        //     });
        // },
        // setInformation(boolean) {
        //     this.information = boolean;
        //     this.$bvModal.show('modalInactive')
        // }
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
$primary-color: #6f6963;
$secondary-color: #a7907b;
.coffee:after {
    display: none;
}
.wrapper-bg {
    padding-bottom: 0px !important;
}
.main-layout {
    .text-center {
        margin-bottom: 20px;
    }
    .main-container {
        margin-top: 100px;
        display: flex;
        align-items: center;
        flex-direction: column;
        .title {
            color: #a7907b;
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 20px;
        }
        .Line-18 {
            width: 90%;
            height: 1px;
            flex-grow: 0;
            background-color: #b79377;
            margin-bottom: 20px;
        }
        .desc {
            font-size: 16px;
            color: #b79377;
        }
    }
    // .profile-container {
    //     margin: 0 auto 22px;
    //     height: 63px;
    //     position: relative;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     .profile-image {
    //         border-radius: 50%;
    //         border: 3px solid $secondary-color;
    //         height: 3.5rem;
    //         width: 3.5rem;
    //         overflow: hidden;
    //         float: left;
    //         margin-right: 12px;
    //         img {
    //             width: 100%;
    //         }
    //     }
    //     .point-container{
    //         .nestle-point{
    //             color: $secondary-color;
    //             font-family: "PromptSemiBold";
    //             font-size: 16px;
    //             margin-bottom: 5px;
    //         }
    //         .expire-date{
    //             font-size: 11px;
    //             color: #fff;
    //         }
    //     }
    // }
    // .inactive-body{
    //     margin: 20px;
    //     background-color: #000;
    //     border-radius: 10px;
    //     padding: 20px;
    //     text-align: center;

    //     .inactive-title{
    //         font-size: 16px;
    //         font-family: "PromptSemiBold";
    //         color: $light-brown;
    //         padding: 16px 23px 4px;
    //     }
    //     .inactive-desc{
    //         font-size: 1rem;
    //         font-weight: 400;
    //         margin-bottom: 25px;
    //     }
    //     .btn-container{
    //         font-size: 16px;
    //         font-family: "PromptSemiBold";
    //         .brown-btn{
    //             margin-bottom: 15px;
    //         }
    //         .gray-btn{
    //             margin-bottom: 15px;
    //         }
    //     }
    // }
}
// .order-main{
//     .order-header{
//         margin: 7px;
//     }
//     .underline-btn{
//         color: #000;
//         padding: 10px;
//     }
//     .success-desc{
//         color: #000;
//         text-align: center;
//         padding: 0 50px 23px;
//     }
// }
</style>
